var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoDel2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.77778 9.63061H16.2222L16.2241 19.1043H6.77778V9.63061ZM4.88889 19.1043C4.88889 20.1502 5.73606 20.999 6.77778 20.999H16.2222C17.2639 20.999 18.1111 20.1502 18.1111 19.1043V7.73588H4.88889V19.1043ZM14.3333 4.89473V3H8.66667V4.89473H3V6.78852H20V4.89473H14.3333Z",
    fill: "#FF6A61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66669 17.2096H10.5556V11.5254H8.66669V17.2096ZM12.4445 17.2096H14.3334V11.5254H12.4445V17.2096Z",
    fill: "#FF6A61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDel2);
export default __webpack_public_path__ + "static/media/ico-del2.75948d43fbbda3c2b5fe83b559b7745d.svg";
export { ForwardRef as ReactComponent };